
import { Component, Prop, Vue } from "vue-property-decorator";
import CleanListTwoParams from "@/components/CleanListTwoParams.vue";

@Component({
  props: {
    click: Function,
    clickImage: Function,
    title: String,
    hasMoreButton: Boolean,
    img: String,
  },
  components: { CleanListTwoParams },
})
export default class HeaderModality extends Vue {}
